<template>
    <v-card class="elevation-1">
        <v-toolbar flat height="37">
            <span class="primary--text font-weight-bold">MY FAVORITES</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <v-chip v-for="(item, index) in favorites" :key="index" @click="$router.push(`${item.pagePath}`)" >
                <v-icon>{{ item.pageIcon }}</v-icon>
                <span class="ml-5 clickable">{{ item.pageName }}</span>
            </v-chip>
        </v-card-text>
    </v-card>
</template>

<script>
export default {     
    name: 'MyFavorites',
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
        }
    },
    computed: {
        favorites() {
            return this.$store.getters.favorites
        },
    }
}
</script>